require.register("search/controllers/indexCtrl", function(exports, require, module){
  $0
  
});

